module.exports = {"411502001":"老城街道","411502002":"民权街道","411502003":"车站街道","411502004":"五里墩街道","411502005":"五星街道","411502006":"湖东街道","411502007":"南湾街道","411502008":"金牛山街道","411502009":"双井街道","411502100":"李家寨镇","411502101":"吴家店镇","411502102":"东双河镇","411502103":"董家河镇","411502104":"浉河港镇","411502203":"游河乡","411502206":"谭家河乡","411502207":"柳林乡","411502208":"十三里桥乡"}


//////////////////
// WEBPACK FOOTER
// ./src/town/411502.json
// module id = 1518
// module chunks = 0